export default __webpack_public_path__ + "static/media/junk1.5f5d5047.svg";